// extracted by mini-css-extract-plugin
export default {"ticketsLayout":"TicketsLayout_ticketsLayout__ZTTX+"};